import { AuthError } from "aws-amplify/auth";
import { useParams } from "react-router-dom";

import { useGetAuthUser } from "@/api/get-user";
import { useGetSessionByKey } from "@/features/session/api/get-session-by-key";
import { HttpError } from "@/types/error";
import { User } from "@/types/user";
import { SessionByRoomKey } from "@classview/shared-types";
import { UseQueryResult } from "@tanstack/react-query";

/**
 * This hook is used to check if the user can join the session,
 * based on the session settings and user permissions.
 */
export function useCanUserJoin(): {
  /**
   * If a user has been invited or the session is public, this will be true.
   */
  canJoinSession: boolean;
  session: UseQueryResult<SessionByRoomKey, HttpError>;
  user: UseQueryResult<User, AuthError>;
} {
  const { key } = useParams();

  const session = useGetSessionByKey(key ?? "");
  const user = useGetAuthUser();
  const canJoinSession = user.isSuccess && session.isSuccess;

  return {
    canJoinSession,
    session,
    user,
  };
}
